import { ILanguage } from "./company";
import { ISurveyType } from "./dto";
import { IMeetingDetail } from "./meeting";

export interface ISurvey {
    id: number;
    question: string;
    odg: string;
    open_close: string;
    surveyType: string;
    vote: string;
    isVotes: boolean;
    nodeId: number
  }

export interface ISurveyQuestionLanguages{
  languageId:number;
  question:string;
  } 

export interface ISurveyResponseDetails{
  id:number
  surveyQuestionId:number,
  orderPos:number,
  status:boolean,
  canEdit: boolean
  responselanguages:ISurveyResponselanguage[],
}

export interface ISurveyResponselanguage{
  languageId:number,
  response:string
}

export interface ISurveyQuestion{
  id:number;
  questiontypeid:number;
  orderpos:number;
  maxNumberAnswer:number;
  voteFrom:number;
  voteTo:number;
}
export interface ISurveyDetail{
  surveyId:number;
  nodeId:number;
  surveyQuestionTypeId:number;
  isOpen:boolean;
  obligatoryAnswer:boolean;
  quorumPercentual:number;
  quorumInt:number;
  maxNumberAnswer:number;
  voteFrom:number;
  voteTo:number;
  quorumType:string;
  categorySurvey:string;
  surveyQuestionId:number;
  canEdit: boolean;
  answers: boolean;
  questionsLanguages:  ISurveyQuestionLanguages[]

}

export class SurveyDetailFormValues implements ISurveyDetail{
  meetingId:number=0
  surveyId:number=0;
  nodeId:any
  surveyQuestionTypeId:number=0;
  isOpen:boolean=false;
  obligatoryAnswer: boolean=false;
  quorumPercentual: number=0;
  quorumInt:number=0;
  maxNumberAnswer:number=0;
  voteFrom:number=0;
  voteTo:number=0 ;
  categorySurvey:string="";
  quorumType: string="";
  surveyQuestionId: number=0;
  canEdit: boolean=false;
  answers: boolean=false
  questionsLanguages: ISurveyQuestionLanguages[]=[];
  selectedLanguages: number[]=[]
  
  constructor(init?: ISurveyDetail) {
    Object.assign(this, init);
  }

}


export class SurveyQuestionFormValues implements ISurveyQuestionLanguages{
  languageId: number=0;
  question: string="";

     constructor(init?: ISurveyQuestionLanguages) {
       Object.assign(this, init);
     }
}



export interface ISurveyResponseFormValue{
  responseLanguages: ISurveyResponselanguage[];
}


export class SurveyResponseFormValue implements ISurveyResponseFormValue{
  responseLanguages: ISurveyResponselanguage[]=[];
  
  constructor(init?: ISurveyResponseFormValue) {
    Object.assign(this, init);
  }
}  

export class SurveyResponseLanguagesFormValue implements ISurveyResponselanguage{
  languageId: number=0;
  response: string="";
  constructor(init?: ISurveyResponselanguage) {
    Object.assign(this, init);
  }
}
  

export interface ISurveyEvent {
  meetingId: number,
  event: string
}

export class SurveyEvent implements ISurveyEvent{
  meetingId: number=0;
  event: string="";

   constructor(init?: ISurveyEvent) {
    Object.assign(this, init);
  }
}


export interface ISurveyResultTotal{
  response: string,
  users: string,
  numberVote: number,
  percentualVote: number,
}


export interface ISurveyResultSingle{
   user: string,
   date: string,
   votes: string,
}


export interface IQuorumResult{
  quorum: string,
  quorumVoters: number,
  numberVotes: number,
  status: string,
  numberUsers: number,
  quorumPercentual: number
}

export interface ISurveyDetailsDto {
  languages: ILanguage[];
  meetingTitle: string;
  meetingDetails: IMeetingDetail;
  odgTitle: string;
  surveyTypes:ISurveyType[];
  survey: ISurveyDetail;
  canViewODG:boolean
}


export interface SurveyDetailsPlayerDto {
  answers: number[];
  answersVote: AnswerVotePlayerdto[];
  answerFree: string;
  answerDate: string;
  survey: SurveyPlayerDto;
  responses: SurveyResponsesCustomPlayer[];
}

export interface AnswerVotePlayerdto {
  responseId: number;
  vote: number;
}

export interface SurveyPlayerDto {
  surveyId: number;
  surveyQuestionTypeId: number;
  maxNumberAnswer: number;
  voteFrom: number;
  voteTo: number;
  surveyQuestionId: number;
  questionsLanguages: SurveyQuestionLanguageDto;
}

export interface SurveyResponsesCustomPlayer {
  responseId: number;
  response: string;
}

export interface SurveyQuestionLanguageDto {
  languageId: number;
  question: string;
}

export interface SurveyStarsVote{
  responseId: number;
  vote: number;
}

export interface Votes{
  votes: SurveyStarsVote[]
}


var surveyQuestionType = {
  Single: 1,
  Multiple: 2,
  Rating: 3,
  Free: 4,
};

export default surveyQuestionType;









